import React, { useState } from 'react'

function ClearIcon(props) {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         width="17.798"
         height="21.753"
         viewBox="0 0 17.798 21.753"
         {...props}
      >
         <path
            fill={props.color}
            d="M120 157.753v-7.169a4.708 4.708 0 014.7-4.7h1.483v-8.4a1.488 1.488 0 011.48-1.484h2.472a1.487 1.487 0 011.483 1.483v8.4h1.482a4.69 4.69 0 014.7 4.7v7.169zm1.483-1.483h2.6v-3.213a.7.7 0 01.222-.528.741.741 0 01.531-.213.7.7 0 01.519.213.723.723 0 01.21.528v3.213h2.6v-3.213a.7.7 0 01.222-.528.741.741 0 01.531-.213.7.7 0 01.519.213.723.723 0 01.21.528v3.213h2.6v-3.213a.7.7 0 01.222-.528.741.741 0 01.531-.213.7.7 0 01.519.213.723.723 0 01.21.528v3.213h2.6v-5.685a3.2 3.2 0 00-3.213-3.213h-8.4a3.2 3.2 0 00-3.213 3.213zm8.652-10.382v-8.4h-2.472v8.4z"
            transform="translate(-120 -136)"
         ></path>
      </svg>
   )
}

export default ClearIcon
